// Amber masquerade banner — visible only when an admin is viewing the app as
// another user. Lives at z-100 above all content.
import React from 'react';
import { EyeOff, X } from 'lucide-react';

export const MasqueradeBanner = ({ masqueradeUser, onExit }) => (
  <div
    className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm font-medium shadow-lg"
    data-testid="masquerade-banner"
  >
    <div className="flex items-center gap-2">
      <EyeOff className="w-4 h-4" />
      <span>
        Viewing as <strong>{masqueradeUser?.name}</strong> ({masqueradeUser?.email})
        {' — '}{masqueradeUser?.role?.replace('domain_', '')}
      </span>
    </div>
    <button
      onClick={onExit}
      className="flex items-center gap-1.5 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-lg transition-colors"
      data-testid="exit-masquerade-btn"
    >
      <X className="w-3.5 h-3.5" />
      Exit Masquerade
    </button>
  </div>
);
